import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@/lib/proto/advai_event/atome_id/action_pb'
import LazyLoad from 'react-lazyload'
import { getUuid, isApp } from '@/lib/utils'

const ApplyNowFloatBtn = () => {
  const { width } = useWindowSize()
  const isFromMobile = width < 1000
  const handleFloatingBtnLink = () => {
    if (isApp()) {
      return
    }
    eventLogProducer.push({
      action: Action.FLOATINGBUTTONCLICK,
    })

    location.href = `${
      process.env.NEXT_PUBLIC_GROWTH_HOST
    }/OFFICIAL2021/login?utm_source=OfficialWebsite&utm_campaign=BlogArticle&cid=${getUuid()}`
  }

  return (
    <ApplyNowBtnStyles>
      {isFromMobile && !isApp() && (
        <LazyLoad>
          <img
            onClick={handleFloatingBtnLink}
            className="banner-apply-now-float-btn"
            src="/images/edu/apply-now.png"
            alt=""
          />
        </LazyLoad>
      )}
    </ApplyNowBtnStyles>
  )
}

export default ApplyNowFloatBtn

const ApplyNowBtnStyles = styled.div`
  @media only screen and (min-width: 1000px) {
    .banner-apply-now-float-btn {
      width: 164px;
      height: 164px;
      position: fixed;
      top: 42%;
      right: 35px;
      z-index: 9999;
    }
  }
  @media only screen and (max-width: 1000px) {
    .banner-apply-now-float-btn {
      width: 88px;
      height: 88px;
      position: fixed;
      top: 39%;
      right: 10px;
      z-index: 9999;
    }
  }
`
